import React, { useState, useContext, useEffect } from "react";
import DashboardLayout from "./DashboardLayout";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { CustomerContext } from "../context/customerContext";
import DateObject from "react-date-object";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { getComplaints } from "../services/ComplaintsService";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
  FaInfoCircle,
} from "react-icons/fa";

const ComplaintsList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [complaints, setComplaints] = useState([]);
  const { customer, setCustomer } = useContext(CustomerContext);

  useEffect(() => {
    const fetchComplaintsData = async () => {
      try {
        const response = await getComplaints();
        if (Array.isArray(response.data)) {
          const customerComplaints = response.data.filter(
            (c) => c.customerPartyRef === customer?.partyRef
          );
          setComplaints(customerComplaints);
        } else {
          console.warn("خروجی آرایه نیست:", response.data);
          setComplaints([]);
        }
      } catch (error) {
        console.error("خطا در دریافت اطلاعات شکایات:", error);
      }
    };

    if (customer?.partyRef) fetchComplaintsData(); // ✅ استفاده از partyref واقعی
  }, [customer]);


  if (!complaints) {
    return (
      <DashboardLayout>
        <div className="text-center text-blue-800">
          در حال بارگذاری اطلاعات اعلانات و شکایات...
        </div>
      </DashboardLayout>
    );
  }

  const toPersianDigits = (str) =>
  str.toString().replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);

  return (
    <DashboardLayout>
      <div className="flex items-center justify-between  mb-4">
        <h1 className="text-base sm:text-lg md:text-xl font-bold text-blue-700">
          اعلانات و شکایات
        </h1>
        <div className="flex flex-col sm:flex-row items-center gap-2">
          <button
            onClick={() => navigate("/complaints-request")} // مسیر صفحه ثبت درخواست جدید
            className="px-3 py-1  hover:bg-blue-700 text-white text-sm rounded bg-green-600"
          >
            ثبت درخواست
          </button>
          <button
            onClick={() => navigate(-1)}
            // className="px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded"
            className="px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded min-w-[108px] sm:min-w-0"
          >
            بازگشت
          </button>
        </div>
      </div>

      <div className="mx-6 mb-6 rounded-xl border border-blue-200 bg-blue-50 p-5 shadow-sm">
        <h2 className="text-lg font-bold text-blue-700 mb-3">
          واحد رسیدگی به اعلانات و شکایات مشتریان
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-gray-700">


          {/* <p className="mb-2">
                    <span className="font-semibold">📱 موبایل:</span>{" "}
                    <a
                      href="tel:09121234567"
                      className="text-blue-600 hover:underline"
                    >
                      0912-123-4567
                    </a>
                  </p> */}

          <div className="space-y-3">

            <div className="flex items-center gap-2">
              <FaPhoneAlt className="text-blue-600" />
              <span className="font-semibold">تلفن:</span>
              <span className="text-blue-600 tracking-wider">
               {toPersianDigits("021-66804766")}
              </span>
            </div>

            <div className="flex items-center gap-2">
              <FaEnvelope className="text-blue-600" />
              <span className="font-semibold">ایمیل:</span>
              <a
                href="mailto:h.ghasemi@doosheh.com"
                className="text-blue-600 hover:underline"
              >
                h.ghasemi@doosheh.com
              </a>
            </div>

          </div>

          <div className="space-y-1">
            <div className="flex items-center gap-2">
              <FaClock className="text-blue-600" />
              <span className="font-semibold">ساعات پاسخگویی:</span>
            </div>

            <p className="mr-7">شنبه تا چهارشنبه</p>
            <p className="mr-7">{toPersianDigits("8:30 الی 17:00")}</p>
          </div>
        </div>

        <div className="mt-4 rounded-lg bg-white border border-blue-100 p-3 text-sm text-gray-600">
          <p className="font-semibold text-blue-700 mb-2">راهنمای ثبت درخواست</p>
          <ul className="list-disc pr-5 space-y-1">
            <li>لطفاً موضوع درخواست را به‌درستی انتخاب کنید.</li>
            <li>در صورت امکان شماره فاکتور یا شماره حواله را در متن درخواست ذکر کنید.</li>
            <li>شرح کامل مشکل باعث تسریع در رسیدگی خواهد شد.</li>
          </ul>
        </div>
      </div>

      <div className="w-full overflow-x-auto rounded-xl">
        <table className="w-full min-w-[400px] sm:min-w-[500px] text-sm text-right bg-white shadow rounded-xl overflow-hidden">
          <thead className="bg-blue-100 text-blue-900">
            <tr>
              <th className="px-3 py-1 sm:px-2 sm:py-2">ردیف</th>
              <th className="px-3 py-1 sm:px-2 sm:py-2">شماره درخواست</th>
              <th className="px-3 py-1 sm:px-2 sm:py-2">گروه درخواست</th>
              <th className="px-3 py-1 sm:px-2 sm:py-2">تاریخ ایجاد</th>
              <th className="px-2 py-1 sm:p-3">وضعیت</th>
            </tr>
          </thead>
          <tbody>
            {complaints.map((item, index) => (
              <tr key={item.id} className="border-t hover:bg-blue-50">
                <td className="px-3 py-1 sm:px-2 sm:py-2 ">{index + 1}</td>{" "}
                {/* شماره ردیف */}
                <td className="px-3 ۰py-1 sm:px-2 sm:py-2 text-blue-700 font-bold">
                  <Link
                    to={`/complaints-details/${item.requestNo}`}
                    className="hover:underline"
                  >
                    {item.requestNo}
                  </Link>
                </td>
                <td className="px-3 py-1 sm:px-2 sm:py-2 ">
                  {item.complaintGroupName}
                </td>
                {/* <td className="p-3">{inv.date.split("T")[0]}</td> */}
                <td className="px-3 py-1 sm:px-2 sm:py-2 ">
                  {new DateObject({
                    date: item.createDate,
                    calendar: "gregorian", // مشخص کردن ورودی میلادی
                  })
                    .convert(persian) // تبدیل به تقویم شمسی
                    .format("YYYY/MM/DD")}
                </td>
                <td className="px-3 py-1 sm:px-2 sm:py-2 ">
                  {item.complaintStatusName}
                </td>
              </tr>
            ))}
            {complaints.length === 0 && (
              <tr>
                <td colSpan="4" className="p-4 text-center text-gray-500">
                  رکوردی یافت نشد.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </DashboardLayout>
  );
};

export default ComplaintsList;
